exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table.reservations tbody {\n  margin-bottom: 20px;\n}\ntable.reservations tr.spacer td {\n  height: 50px;\n}\ntable.reservations td[href] {\n  cursor: pointer;\n}\ntr.waitingBooking {\n  background-color: #fff4f3;\n}\ntr.waitingBooking td.conf span.label {\n  font-weight: bold;\n}\ntd.conf {\n  width: 120px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js??ref--1-2!./client/assets/scripts/modules/reservations/dayview/styles.less
// module id = 319
// module chunks = 1